// update-customer-reducer.js
import {
    UPDATE_CUSTOMER_REQUEST,
    UPDATE_CUSTOMER_SUCCESS,
    UPDATE_CUSTOMER_FAILURE,
} from '../actions/update-customer-actions';

const initialState = {
    isLoading: false,
    error: null,
    success: false,
};

export default function updateCustomerReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_CUSTOMER_REQUEST:
            return { ...state, isLoading: true, error: null, success: false };
        case UPDATE_CUSTOMER_SUCCESS:
            return { ...state, isLoading: false, success: true };
        case UPDATE_CUSTOMER_FAILURE:
            return { ...state, isLoading: false, error: action.payload, success: false };
        default:
            return state;
    }
}
